import _regeneratorRuntime from 'babel-runtime/regenerator';
import _asyncToGenerator from 'babel-runtime/helpers/asyncToGenerator';
import _Number$parseFloat from 'babel-runtime/core-js/number/parse-float';
import _extends from 'babel-runtime/helpers/extends';

/* eslint-disable vue/no-mutating-props */
import { createDemand as _createDemand, updateDemand as _updateDemand } from '@/api/demand/demand';
import _ from 'lodash';
import demandMixin from './demand-mixin';
import { transformTimestampToSeconds } from '@/utils/date';

export default {
  mixins: [demandMixin],

  components: {},

  props: {
    demand: {
      type: Object,
      require: true
    },
    validate: {
      type: Function,
      required: true
    },
    products: {
      type: Array,
      required: true
    },
    id: {
      type: [String, Number],
      require: false
    },
    type: {
      type: String,
      default: 'create'
    },
    creationList: {
      type: Array,
      required: true
    }
  },

  data: function data() {
    return {
      loading: false
    };
  },


  computed: {
    saveButton: function saveButton() {
      return {
        type: 'primary',
        loading: this.loading
      };
    },
    submitButton: function submitButton() {
      return {
        type: 'primary',
        loading: this.loading,
        text: '提交需求'
      };
    }
  },

  methods: {
    // 将表单数据转换为接口所需格式
    getDemand: function getDemand() {
      var _this = this;

      var demand = _.pick(this.demand, ['name', 'instruction', 'category', 'is_pay', 'type', 'is_advertiser_review', 'reference_url', 'reference_name', 'expect_time', 'adv_id', 'status', 'similar_demand_ids', 'material_source', 'key_account', 'channel_type', 'biz_scenario', 'grade']);

      if (this.demand.account_manager_id) {
        demand.account_manager_id = Number(this.demand.account_manager_id);
      }

      // 复制需求需要传源需求 id
      if (this.copyId) {
        demand.copy_id = Number(this.copyId);
      }

      // ss 上传来源素材，创建需求添加 source_object_id
      if (this.isFromSS) {
        demand = _extends({}, demand, {
          source_object_id: Number(this.reviewId)
        });
      }

      // 需求类型=非交互素材&需求归属为 MTG/大媒体 时, 并且非编辑时，赋值 split_num
      if (this.isNoninteractiveAndBidMediaAndMTG && this.pageType !== 'update') {
        demand = _extends({}, demand, {
          split_num: this.demand.split_num
        });
      }

      // 需求归属=大媒体
      if (this.isBigMedia) {
        // 需求类型=非交互素材
        if (this.isNonInteractiveCreation) {
          demand = _extends({}, demand, {
            business_type: this.demand.business_type,
            is_new_order: this.demand.is_new_order

            // 使用模板
          });if (this.demand.big_media_is_use_template === 1) {
            demand.big_media_tpl_id = this.demand.big_media_tpl_id;
          } else if (this.demand.big_media_is_use_template === 2) {
            // 不使用模板
            demand.big_media_creative_type = this.demand.big_media_creative_type === '其他' ? this.demand.big_media_creative_type_other : this.demand.big_media_creative_type;
          }
        }
      }

      // 设计项目
      if (this.isDesign) {
        // 下单日期
        demand.order_time = transformTimestampToSeconds(this.demand.order_time);
        // 服务类型、服务归属
        demand.service_attribution = this.demand.service_attribution || 0;
        demand.service_type = this.demand.service_type || 0;
        // 付费
        if (this.isPay) {
          demand = _extends({}, demand, {
            payment: {
              invoice_id: this.demand.invoice_id,
              currency: this.demand.currency,
              exchange_rate: _Number$parseFloat(this.demand.exchange_rate),
              is_prepaid: this.demand.is_prepaid,
              revenue: this.isUsdSettlement ? _Number$parseFloat(this.demand.revenue_usd) : _Number$parseFloat(this.demand.revenue_cny),
              cost: this.isUsdSettlement ? _Number$parseFloat(this.demand.cost_usd) : _Number$parseFloat(this.demand.cost_cny),
              crm_contract_no: this.demand.crm_contract_no
            }
          });

          if (this.isPrepaid) {
            demand.payment.prepaid_percent = Number(this.demand.prepaid_percent);
          }
        }

        demand.case_auth_type = this.demand.case_auth_type;
        if (this.demand.case_auth_type === 3) {
          demand.case_remark = this.demand.case_remark;
        }

        // 交互素材
        if (this.isInteractiveCreation) {
          demand = _extends({}, demand, {
            ia_material_type: this.demand.ia_material_type,
            is_pt_custom: this.demand.is_pt_custom,
            is_make_dco: this.demand.is_make_dco
          });
        }

        if (this.isNonInteractiveCreation) {
          demand = _extends({}, demand, {
            nia_tag2_id: this.demand.nia_tag2_id,
            nia_tag3_id: this.demand.nia_tag3_id
          });
        }
      }

      demand.project_type = this.demand.project_type || 0;
      if (this.demand.project_type === 99) {
        demand.project_other = this.demand.project_other;
      }

      // 当是交互素材，并且含有 channel_setting 时
      if (this.isInteractiveCreation) {
        var selectChannelIds = this.creationList.map(function (creation) {
          return creation.channel.join();
        }).join();
        demand.channel_setting = {};
        // 当选有巨量引擎时
        if (selectChannelIds.indexOf(9) !== -1) {
          demand.channel_setting.content_rating = this.demand.content_rating !== '-1' ? this.demand.content_rating : '';
        }
        // 当选有 IR 时
        if (selectChannelIds.indexOf(10) !== -1) {
          demand.channel_setting.ir_report_point = this.demand.ir_report_point;
          demand.channel_setting.ir_creative_genre = this.demand.ir_creative_genre;
        }
      }

      var cookCreationSizes = function cookCreationSizes(creation) {
        if (_.isArray(creation.sizes) && creation.sizes.length > 0) {
          return creation.sizes.join() || '';
        }
        return '';
      };
      var cookCreationTasks = function cookCreationTasks() {
        return _.cloneDeep(_this.creationList).map(function (creation) {
          var newCreation = {
            channel_ids: _this.demand.type === 1 ? creation.channel.join() : String(creation.channel),
            creation_type: _this.demand.type === 1 ? _this.demand.interactive_type : creation.type,
            languages: creation.languages ? creation.languages.join() : '',
            creation_sizes: cookCreationSizes(creation) || '',
            id: creation.id
          };
          return _.pickBy(newCreation, function (val) {
            return val !== '';
          });
        });
      };
      var cookProducts = function cookProducts() {
        return _this.products.map(function (product) {
          var newProduct = _.pick(product, ['id', 'app_id', 'app_name', 'app_url', 'package_name', 'offer_uuid']);

          if (product.mtg_daily_cost) {
            newProduct.daily_cost = product.mtg_daily_cost;
          }

          // 过滤掉空字符串
          newProduct = _.pickBy(newProduct, function (val) {
            return val !== '';
          });

          return _extends({}, newProduct, {
            platform: product.platform ? product.platform.toLowerCase() : ''
          });
        });
      };

      demand = _extends({}, demand, {
        products: cookProducts(),
        creation_tasks: cookCreationTasks(),
        similar_demand_ids: this.demand.similar_demand_ids ? this.demand.similar_demand_ids.join() : '',
        platforms: this.demand.platform,
        // reference_url 只能传服务器存储的临时 URL（在编辑需求的时候如果没有重新上传文件，那么传的时 S3 的文件链接，那么直接传空字符串即可）
        reference_url: /^portal.+/.test(demand.reference_url) ? demand.reference_url : '',
        reference_name: /^portal.+/.test(demand.reference_url) ? demand.reference_name : '',
        // 广告主选择组件返回的是字符串的 id
        account_manager_id: Number(demand.account_manager_id)
      });

      return _extends({}, _.pickBy(demand, _.identity));
    },
    beforeSubmit: function beforeSubmit() {
      var _this2 = this;

      return _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee() {
        return _regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                if (!(_this2.isNoninteractiveAndBidMediaAndMTG && _this2.pageType === 'update')) {
                  _context.next = 4;
                  break;
                }

                if (!(_this2.creationList.length > 1 || _this2.creationList[0].languages.length > 1)) {
                  _context.next = 4;
                  break;
                }

                _this2.$message.error('大媒体和MTG的非交互并且编辑状态下，只允许渠道x语言数量=1');
                return _context.abrupt('return', false);

              case 4:
                _context.next = 6;
                return _this2.validate();

              case 6:
                return _context.abrupt('return', _context.sent);

              case 7:
              case 'end':
                return _context.stop();
            }
          }
        }, _callee, _this2);
      }))();
    },
    back: function back() {
      window.history.back();
    },
    save: function save() {
      var _this3 = this;

      return _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee4() {
        var status, utils;
        return _regeneratorRuntime.wrap(function _callee4$(_context4) {
          while (1) {
            switch (_context4.prev = _context4.next) {
              case 0:
                status = 'unsubmit';
                utils = {
                  create: function () {
                    var _ref = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee2() {
                      var demand;
                      return _regeneratorRuntime.wrap(function _callee2$(_context2) {
                        while (1) {
                          switch (_context2.prev = _context2.next) {
                            case 0:
                              demand = _extends({}, _this3.getDemand(), { status: status });
                              _context2.next = 3;
                              return _this3.createDemand(demand);

                            case 3:
                            case 'end':
                              return _context2.stop();
                          }
                        }
                      }, _callee2, _this3);
                    }));

                    return function create() {
                      return _ref.apply(this, arguments);
                    };
                  }(),
                  update: function () {
                    var _ref2 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee3() {
                      return _regeneratorRuntime.wrap(function _callee3$(_context3) {
                        while (1) {
                          switch (_context3.prev = _context3.next) {
                            case 0:
                              _context3.next = 2;
                              return _this3.updateDemand(_extends({}, _this3.getDemand(), { status: status }));

                            case 2:
                            case 'end':
                              return _context3.stop();
                          }
                        }
                      }, _callee3, _this3);
                    }));

                    return function update() {
                      return _ref2.apply(this, arguments);
                    };
                  }()
                };
                _context4.next = 4;
                return _this3.beforeSubmit();

              case 4:
                if (!_context4.sent) {
                  _context4.next = 6;
                  break;
                }

                utils[_this3.type] && utils[_this3.type]();

              case 6:
              case 'end':
                return _context4.stop();
            }
          }
        }, _callee4, _this3);
      }))();
    },
    submit: function submit() {
      var _this4 = this;

      return _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee7() {
        var status, utils;
        return _regeneratorRuntime.wrap(function _callee7$(_context7) {
          while (1) {
            switch (_context7.prev = _context7.next) {
              case 0:
                status = 'submited';
                utils = {
                  create: function () {
                    var _ref3 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee5() {
                      return _regeneratorRuntime.wrap(function _callee5$(_context5) {
                        while (1) {
                          switch (_context5.prev = _context5.next) {
                            case 0:
                              _context5.next = 2;
                              return _this4.createDemand(_extends({}, _this4.getDemand(), { status: status }));

                            case 2:
                            case 'end':
                              return _context5.stop();
                          }
                        }
                      }, _callee5, _this4);
                    }));

                    return function create() {
                      return _ref3.apply(this, arguments);
                    };
                  }(),
                  update: function () {
                    var _ref4 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee6() {
                      return _regeneratorRuntime.wrap(function _callee6$(_context6) {
                        while (1) {
                          switch (_context6.prev = _context6.next) {
                            case 0:
                              _context6.next = 2;
                              return _this4.updateDemand(_extends({}, _this4.getDemand(), { status: status }));

                            case 2:
                            case 'end':
                              return _context6.stop();
                          }
                        }
                      }, _callee6, _this4);
                    }));

                    return function update() {
                      return _ref4.apply(this, arguments);
                    };
                  }()
                };
                _context7.next = 4;
                return _this4.beforeSubmit();

              case 4:
                if (!_context7.sent) {
                  _context7.next = 6;
                  break;
                }

                utils[_this4.type] && utils[_this4.type]();

              case 6:
              case 'end':
                return _context7.stop();
            }
          }
        }, _callee7, _this4);
      }))();
    },
    createDemand: function createDemand(params) {
      var _this5 = this;

      return _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee8() {
        return _regeneratorRuntime.wrap(function _callee8$(_context8) {
          while (1) {
            switch (_context8.prev = _context8.next) {
              case 0:
                _this5.loading = true;

                _context8.prev = 1;
                _context8.next = 4;
                return _createDemand(params);

              case 4:
                _this5.loading = false;
                _this5.$message({ message: '提交需求成功', type: 'success' });
                _this5.$router.push({
                  name: 'butler.submitted-demand.demand'
                });
                _context8.next = 12;
                break;

              case 9:
                _context8.prev = 9;
                _context8.t0 = _context8['catch'](1);

                _this5.loading = false;

              case 12:
              case 'end':
                return _context8.stop();
            }
          }
        }, _callee8, _this5, [[1, 9]]);
      }))();
    },
    updateDemand: function updateDemand(params) {
      var _this6 = this;

      return _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee9() {
        return _regeneratorRuntime.wrap(function _callee9$(_context9) {
          while (1) {
            switch (_context9.prev = _context9.next) {
              case 0:
                _this6.loading = true;

                _context9.prev = 1;
                _context9.next = 4;
                return _updateDemand(_this6.id, params);

              case 4:
                _this6.loading = false;
                _this6.$message({ message: '提交需求成功', type: 'success' });
                _this6.back();
                _context9.next = 13;
                break;

              case 9:
                _context9.prev = 9;
                _context9.t0 = _context9['catch'](1);

                _this6.loading = false;
                _this6.$message.error(_context9.t0.message || '提交需求失败');

              case 13:
              case 'end':
                return _context9.stop();
            }
          }
        }, _callee9, _this6, [[1, 9]]);
      }))();
    }
  }
};